import { styled } from '@clickcease/cc-client-components-lib'

export const CqParamsModalStyled = styled('div', {
  width: '644px',
  padding: '24px',
  height: '530px',
})

export const CodeWrapper = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',

  color: '$mainTextColor',
  width: 'fit-content',
  padding: '$3 $6',
  border: '1px dashed #9B9B9B',
  borderRadius: '4px',
  background: '$tableHovered',
  marginBottom: '16px',
})
